/* 首页 */
<template>
  <div class="home-box">
    <!-- 头部 -->
    <headerTop title="叮当云帐本" :type="0"></headerTop>
    <!-- 内容 -->
    <div class="content">
      <div class="none-box">
        <label>本月</label>
        <div class="total">
          <span>{{ monthTotalPrice | formatPirce }}</span>
        </div>
        <img class="background" src="../../assets/images/home-bg@2x.png" alt="">
      </div>
      <div class="grid">
        <div class="row">
          <!-- <div class="grid-item" @click="handleToDetail('commission', '业绩提成')"> -->
          <div class="grid-item">
            <div class="name">业绩提成</div>
            <!-- <div class="price">{{ (commissionTotalPrice*0.01).toFixed(2) }}</div> -->
            <div class="red">
              {{commissionMonthPrice | formatPirce}} ↑
              <!-- <span>本月</span> -->
            </div>
            <!-- <div class="more">
              详情
              <span class="iconfont iconyoujiantou"></span>
            </div> -->
          </div>
          <!-- <div class="grid-item" @click="handleToDetail('levelAward', '平级奖')"> -->
          <div class="grid-item">
            <div class="name">感恩奖</div>
            <!-- <div class="price">{{ (LevelAwardTotalPrice*0.01).toFixed(2) }}</div> -->
            <div class="red">
              {{ LevelAwardMonthPrice | formatPirce }} ↑
              <!-- <span>本月</span> -->
            </div>
            <!-- <div class="more">
              详情
              <span class="iconfont iconyoujiantou"></span>
            </div> -->
          </div>
        </div>
        <div class="row">
          <div class="grid-item">
          <!-- <div class="grid-item" @click="handleToDetail('personally', '个人分红')"> -->
            <div class="name">月度销售提成</div>
            <div class="red">{{ personallyMonthprice | formatPirce }} ↑</div>
            <!-- <div class="more">
              详情
              <span class="iconfont iconyoujiantou"></span>
            </div> -->
          </div>
          <!-- <div class="grid-item" @click="handleToDetail('dividend', '全网分红')"> -->
          <div class="grid-item">
            <div class="name">月度销售奖励</div>
            <div class="red">{{ monthDividend | formatPirce }} ↑</div>
            <!-- <div class="more">
              详情
              <span class="iconfont iconyoujiantou"></span>
            </div> -->
          </div>
        </div>
        <div class="row">
          <div class="grid-item">
          <!-- <div class="grid-item" @click="handleToDetail('personally', '个人分红')"> -->
            <div class="name">培育提成</div>
            <div class="red">{{ monthBuguIncome | formatPirce }} ↑</div>
            <!-- <div class="more">
              详情
              <span class="iconfont iconyoujiantou"></span>
            </div> -->
          </div>
          <!-- <div class="grid-item" @click="handleToDetail('dividend', '全网分红')"> -->
          <div class="grid-item">
            <div class="name">培育分红</div>
            <div class="red">{{ monthDirectorIncome | formatPirce }} ↑</div>
            <!-- <div class="more">
              详情
              <span class="iconfont iconyoujiantou"></span>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import javaApi from "@/api/javaApi";
import headerTop from "@/components/common/headerTop.vue";

export default {
  data() {
    return {
      finalTotalPrice: "",
      monthTotalPrice: "",
      commissionTotalPrice: "",
      commissionMonthPrice: "",
      LevelAwardTotalPrice: "",
      LevelAwardMonthPrice: "",
      personallyTotalprice: "",
      personallyMonthprice: "",
      totalDividend: "",
      monthDividend: "",
      monthBuguIncome: "",
      monthDirectorIncome: "",

    };
  },
  components: {
    headerTop
  },
  filters: {
    formatPirce(val){
      return val ? (val*0.01).toFixed(2) : 0;
    }
  },
  activated() {
    javaApi.comissionSum({}).then(res => {
      this.finalTotalPrice = res.finalTotalPrice || 0; // 累计收益
      this.commissionTotalPrice = res.commissionTotalPrice || 0; // 业绩提成
      this.commissionMonthPrice = res.commissionMonthPrice || 0;
      this.LevelAwardTotalPrice = res.LevelAwardTotalPrice || 0; // 平级奖
      this.LevelAwardMonthPrice = res.LevelAwardMonthPrice || 0;
      this.personallyTotalprice = res.personallyTotalprice || 0; // 个人
      this.personallyMonthprice = res.personallyMonthprice || 0;
      this.monthDividend = res.monthDividend || 0; // 全网分红
      this.totalDividend = res.totalDividend || 0;
      this.monthTotalPrice = res.monthTotalPrice || 0;
      this.monthBuguIncome = res.monthBuguIncome || 0;  //培育分红
      this.monthDirectorIncome = res.monthDirectorIncome || 0;  //培育提成

    });
  },
  methods: {
    handleToDetail(type, name) {
      this.$router.push({
        name: "incomeDetail",
        query: {
          type: type,
          name: name
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.home-box {
  .none-box {
    position: relative;
    margin: 15px 20px 25px;
    label {
      position: absolute;
      font-size: 14px;
      line-height: 1.5;
      color: #ffffff;
      top: 20px;
      left: 55px;
    }
    .total {
      position: absolute;
      top: 50px;
      left: 25px;
      span {
        font-size: 28px;
        line-height: 1.5;
        color: #ffffff;
        font-weight: bold;
      }
    }
    .background {
      display: block;
      width: 100%;
      height: 100%;
    }
  }
  .grid {
    border-top: 1px solid #eeeeee;
    .row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .grid-item {
        width: 50%;
        text-align: center;
        border-bottom: 1px solid #eeeeee;
        padding: 30px 20px;
        &:first-child {
          border-right: 1px solid #eeeeee;
        }

        .name {
          font-size: 15px;
          color: #666666;
          line-height: 1.5;
        }

        .price {
          font-size: 20px;
          color: #333333;
          line-height: 1.5;
          margin-top: 10px;
          font-weight: bold;
        }

        .red {
          font-size: 14px;
          color: #ff0000;
          line-height: 1.5;
          margin-top: 5px;

          span {
            font-size: 12px;
            color: #666666;
          }
        }

        .more {
          font-size: 12px;
          color: #999999;
          line-height: 1.5;
          text-align: right;
          margin-top: 15px;

          .iconfont {
            font-size: 12px !important;
            color: #999999;
            line-height: 1.5;
          }
        }
      }
    }
  }
}
</style>
